import {
  FileText,
  Pencil,
  Search,
  GitBranch,
  Upload,
  FolderOpen,
  Trash2,
  Cog,
  Terminal,
  type LucideIcon,
} from "lucide-react";

const matchers: [RegExp, LucideIcon][] = [
  [/^Reading\b/, FileText],
  [/^Editing\b/, Pencil],
  [/^Writing\b/, Pencil],
  [/^Searching\b/, Search],
  [/^Listing\b/, FolderOpen],
  [/^Deleting\b/, Trash2],
  [/^Pushing\b/, Upload],
  [/^(Checking git|Reviewing diff|Committing)\b/, GitBranch],
  [/^Running:/, Terminal],
  [/^Running\b/, Cog],
];

export function activityIcon(description: string): LucideIcon {
  for (const [re, icon] of matchers) {
    if (re.test(description)) return icon;
  }
  return Cog;
}
